import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Farm Name",
  "Employe Name",
  "Contact",
  "Date of Joining",
  "Actions",
];

const tableHeadClient = [
  "Sr.",
  "Employe Name",
  "Contact",
  "Date of Joining",
  "Actions",
];

const WorkforceTrakingTable = ({ EX = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const goToView = (id) => {
    navigate(`/client-employee-database/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })
              : tableHead?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
          </tr>
        </thead>
        <tbody>
          {EX?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.farmName || "N/A"}</td>
                )}
                <td>{item?.firstName + " " + item?.lastName || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>{item?.dateOfJoining || "N/A"}</td>
                <td>
                  <CustomViewButton onClick={() => goToView(item?.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WorkforceTrakingTable;
